import { Button, Grid } from '@mui/material'
import React, { useState } from 'react'
import ModeOutlinedIcon from '@mui/icons-material/ModeOutlined';
import DeleteOutlineOutlinedIcon from '@mui/icons-material/DeleteOutlineOutlined';
import CloseIcon from '@mui/icons-material/Close';
import { useDispatch, useSelector } from 'react-redux';
import { setLogicalFilter } from '../../../reduxStore/reducer';
const SelectedFilterLists = () => {
    const dispatch = useDispatch();
    const items = useSelector((state) => state.selectedDimensions.logicalFilter)
    console.log("itemndjbfhg", items[0]);
    const keys = (items.length == 0) ? (Object.keys(items)) : (Object.keys(items[0]))
    console.log("keys", keys);
    const deleteHandeler = (selectedKey)=>{
        console.log("........", items);
        const index = keys.findIndex(item => item === selectedKey);
        console.log((index), items[0]);
        const { id, ...rest } = Object.fromEntries(
            Object.entries(items[0]).filter(([key]) =>
                key !== `${selectedKey}`));
        console.log("rest",rest);
        dispatch(setLogicalFilter([
            {
                ...rest
            }
        ]))    
    }
    const deleteParticularVal =(key,val) =>{
      console.log("val", key,val,items[0][key]);
      let newVal = items[0][key].filter((data)=>{return (data !== val)})
      console.log("newVal", newVal);
      dispatch(setLogicalFilter([
        {
            ...items[0],
            [`${key}`]:newVal
        }
    ])) 
    }
    return (
        <>
            {
                keys.map((key, i) => {
                    return (
                        <Grid container xs={12} 
                        // sx={{ mt: "0.5rem"}}
                        >
                            <Grid xs={12} md={2}>
                                <Button style={{ margin: "1rem", background: "#F3F8FC", boxShadow: "0 4px 8px 0 rgba(0, 0, 0, 0.2), 0 6px 20px 0 rgba(0, 0, 0, 0.19)" }}>
                                    <p style={{ textAlign: "center" }}>{key}</p>
                                </Button>
                            </Grid>
                            <Grid xs={12} md={8.5}>
                                <div style={{ margin: "1rem", background: "#F3F8FC", boxShadow: "0 4px 8px 0 rgba(0, 0, 0, 0.2), 0 6px 20px 0 rgba(0, 0, 0, 0.19)", minHeight: "2rem" }}>
                                    {/* <p style={{textAlign:"center"}}> Lorem ipsum  </p> */}
                                    {
                                        items[0][key].map((val) => {
                                            console.log("val", val);
                                            return (
                                                <div style={{ margin: " 0 0.5rem" }}>
                                                    <div>{val} <span style={{ marginTop: "1rem" }}><Button onClick={()=>{deleteParticularVal(key,val)}}><CloseIcon /></Button></span></div>
                                                </div>
                                            )
                                        })
                                    }
                                </div>
                            </Grid>
                            {/* <Grid xs={12} md={1.5}>
                                <Button sx={{ margin: "1rem", background: "#F3F8FC", boxShadow: "0 4px 8px 0 rgba(0, 0, 0, 0.2), 0 6px 20px 0 rgba(0, 0, 0, 0.19)" }}>
                                    <ModeOutlinedIcon />
                                </Button>

                            </Grid> */}
                            <Grid xs={12} md={1.5}>
                                <Button sx={{ margin: "1rem 0.5rem", background: "#F3F8FC", boxShadow: "0 4px 8px 0 rgba(0, 0, 0, 0.2), 0 6px 20px 0 rgba(0, 0, 0, 0.19)" }} onClick={()=>{deleteHandeler(key)}}>
                                    <DeleteOutlineOutlinedIcon />
                                </Button>

                            </Grid>
                        </Grid>
                    )
                })
            }
        </>


    )
}

export default SelectedFilterLists